module.exports = __webpack_public_path__ + "static/img/1-1.35d66cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/1-1.png
// module id = 5XKL
// module chunks = 0